import { ROUTE_INFOS, RouteInfo } from '../../../../routes';
import { standardizeUrlPathName } from './currentActiveMenu';

export const searchRouteInfos = (searchByField: keyof RouteInfo, value: any): RouteInfo => {
  const results: RouteInfo[] = [];

  const recursiveSearch = (routes: RouteInfo[]) => {
    for (const routeInfo of routes) {
      const runSearch = (field: keyof RouteInfo) => {
        if (field === 'route') {
          if (!routeInfo.route) return false;
          return standardizeUrlPathName(routeInfo.route || '') === standardizeUrlPathName(value);
        }

        return (
          routeInfo[searchByField] &&
          routeInfo[searchByField]?.toString().toLowerCase() === value.toLowerCase()
        );
      };

      const isMetCondition = runSearch(searchByField);

      if (isMetCondition) {
        results.push(routeInfo);
      }

      if (routeInfo.children) {
        recursiveSearch(routeInfo.children);
      }
    }
  };

  recursiveSearch(ROUTE_INFOS);

  return results[0];
};
